import axios from "axios";

async function getAPICount(body){
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'scheduler/farvisionSuccessErrorcountByType', body)
    return response;
}
async function getAPILogs(body){
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'scheduler/fetchAPILogsFromDb', body)
    return response;
}

export {  getAPICount, getAPILogs }